<template>
  <div>
    <!-- -->
    <el-card class="similar">
      <div class="similar-item" v-if="similarList.workUrl">
        <div class="title">以下图片相似度过高，用户已提交证明文件。</div>
        <div class="flex-box">
          <div class="flex-item">
            <el-image
              :src="similarList.workUrl"
              width="20%"
              alt=""
              style="min-width: 200px"
              :preview-src-list="[similarList.workUrl]"
            />
            <div style="display: flex">
              <div>证明材料</div>
              <div>
                <div
                  v-for="(item, index) in similarList.simCetiUrl?.split(',')"
                  :key="index"
                >
                  <el-link type="primary" :href="item" target="_blank">{{
                    similarList.simCetiUrlName?.split(",")[index]
                  }}</el-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="similar-item" v-if="similarList.similarResource?.length">
        <div class="title">相似资源</div>
        <div class="flex-box">
          <div
            class="flex-item flex-item-1"
            v-for="item in similarList.similarResource"
            :key="item.imageId"
          >
            <el-image
              :src="item.imageUrl"
              fit="cover"
              :preview-src-list="
                similarList.similarResource.map((item) => item.imageUrl)
              "
              alt=""
            />
            <div>名称：{{ item.imageName }}</div>
            <div>相似度 {{ item.score }}%</div>
            <div>素材提供：{{ item.imageFrom }}</div>
          </div>
        </div>
      </div>
      <div class="similar-item" v-if="similarList.similarImage?.length">
        <div class="title">相似图片</div>
        <div class="flex-box">
          <div
            class="flex-item"
            v-for="item in similarList.similarImage"
            :key="item.imageId"
          >
            <el-image
              :src="item.imageUrl"
              fit="cover"
              :preview-src-list="
                similarList.similarImage.map((item) => item.imageUrl)
              "
              alt=""
            />
            <div>名称：{{ item.imageName }}</div>
            <div>相似度 {{ item.score }}%</div>
            <div>素材提供：{{ item.imageFrom }}</div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "SlbqWebSimilar",
  props: {
    similarList: {
      type: Object,
      default: () => {
        return {
          similarImage: [],
          similarResource: [],
        };
      },
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
.similar {
  $border: 1px solid #dcdfe6;
  &-item {
    // border-left: $border;
    // border-right: $border;
    // &:last-child {
    //   border-bottom: $border;
    // }
    .title {
      // border-bottom: $border;
      // border-top: $border;
      background: #f6f9ff;
      font-weight: bold;
      padding: 10px;
    }
  }
  .flex-box {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    /* display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
    grid-auto-rows: 1fr;
    grid-auto-columns: 1fr; */

    padding: 20px;
    .flex-item {
      width: calc(20% - 16px);
      min-width: 200px;
      font-size: 14px;
      line-height: 24px;
      div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-image {
        width: 100%;
        height: calc(100% - 80px);
        object-fit: cover;
        background: #fbfbfb;
        border-radius: 5px;
      }
    }
  }
}
</style>
